<template>
  <div class="flex content-center justify-center mt-6">
    <div><img src="https://i.gifer.com/ZZ5H.gif" class="w-8 h-8" alt="" /></div>
    <div class="ml-4 mt-1"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>
